import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/owners/bn.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/owners/combinedImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/owners/do.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/owners/familjenMobileImage.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/owners/client/OwnerCard1.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/owners/client/OwnerCard2.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/owners/client/OwnerCard3.client.jsx");
